/* eslint-disable no-shadow */
import UserClient from '@/api/UserClient';

const srpRefreshPreferenceKey = 'srp_refresh';

const initialState = {
  laneCategoriesToggle: {
    digital: false,
    featured: false,
    private: false,
  },
  searchAndFiltersTab: '',
  srpRefreshPreference: undefined,
  hasFetchedSrpRefreshPreference: false,
  showingEventsDirectory: '',
  dismissedSimulcastPrompt: false,
};

export const state = {
  ...initialState,
};

export const mutations = {
  setLaneCategoryToggle(state, category = false) {
    state.laneCategoriesToggle[category] = !state.laneCategoriesToggle[category];
  },
  setSearchAndFiltersTab(state, tab = '') {
    if (tab) {
      state.searchAndFiltersTab = tab;
    }
  },
  setDefaultMarketplaceView(state) {
    state.laneCategoriesToggle = initialState.laneCategoriesToggle;
    state.searchAndFiltersTab = initialState.searchAndFiltersTab;
  },
  setSrpRefreshPreference(state, value) {
    state.srpRefreshPreference = value;
  },
  changeHasFetchedSrpRefreshPreference(state, value) {
    state.hasFetchedSrpRefreshPreference = value;
  },
  setShowingEventsDirectory(state, showingEventsDirectory = '') {
    state.showingEventsDirectory = showingEventsDirectory;
  },
  setDismissedSimulcastPrompt(state) {
    state.dismissedSimulcastPrompt = true;
  },
};

/*
* Each action for a marketplace param should already be validated to be applicable
*/
export const actions = {
  updateLaneCategoryToggle({ commit }, { category = '' }) {
    commit('setLaneCategoryToggle', category);
  },
  updateSearchAndFiltersTab({ commit }, { tab = '' }) {
    commit('setSearchAndFiltersTab', tab);
  },
  resetMarketplaceView({ commit }) {
    commit('setDefaultMarketplaceView');
  },
  async getSrpRefreshPreference({ rootState, commit, state }) {
    if (state.hasFetchedSrpRefreshPreference) {
      return state.srpRefreshPreference;
    }
    const userClient = new UserClient(rootState.authorization.user);
    let srpRefreshValue;
    try {
      const { data: { data: { [srpRefreshPreferenceKey]: result } } } = await userClient
        .getKeyValueStoreItem(srpRefreshPreferenceKey);
      srpRefreshValue = JSON.parse(result);
    } finally {
      commit('setSrpRefreshPreference', srpRefreshValue ?? undefined);
      commit('changeHasFetchedSrpRefreshPreference', true);
    }

    return srpRefreshValue;
  },

  async toggleSrpRefreshPreference({ rootState, commit, state }, { callbackFn, forceTrue }) {
    const userClient = new UserClient(rootState.authorization.user);

    await userClient.putKeyValueStoreItem(
      srpRefreshPreferenceKey,
      JSON.stringify(forceTrue ? true : !state.srpRefreshPreference),
    );
    commit('changeHasFetchedSrpRefreshPreference', false);

    if (callbackFn) {
      callbackFn(); // after action, handle callback, which should be a reload
    }
  },

  clearSrpRefreshPreference({ commit }) {
    commit('setSrpRefreshPreference', undefined);
    commit('changeHasFetchedSrpRefreshPreference', false);
  },

  updateShowingEventsDirectory({ commit }, showingEventsDirectory = '') {
    commit('setShowingEventsDirectory', showingEventsDirectory);
  },

  dismissSimulcastPrompt({ commit }) {
    commit('setDismissedSimulcastPrompt');
  },
};

export const getters = {
  laneCategoriesToggle: ({ laneCategoriesToggle }) => laneCategoriesToggle,
  searchAndFiltersTab: ({ searchAndFiltersTab }) => searchAndFiltersTab,
  srpRefreshPreference: ({ srpRefreshPreference }) => srpRefreshPreference,
  showingEventsDirectory: ({ showingEventsDirectory }) => showingEventsDirectory,
  dismissedSimulcastPrompt: ({ dismissedSimulcastPrompt }) => dismissedSimulcastPrompt,
};

const marketplaceView = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default marketplaceView;
